import { GraphQLService } from '../../../../server/source/services/graphql-service.ts';
import { Logger } from '../../utils/logger/logger.ts';
import { SsrAppContext } from './app-context.tsx';

export const createSsrAppContext = (options: { logger: Logger }): SsrAppContext => {
  const { logger } = options;
  return {
    logger: options.logger,
    graphqlService: new GraphQLService({ logger })
  };
};
